import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Divider, Menu, MenuItem } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { getSelectedSerialNumbers } from 'features/SerialNumbers/serialNumbers';

interface ProductSerialNumbersMenuProps {
  anchor: null | HTMLElement;
  close: () => void;
  issueSerialNumbers: () => void;
  print: () => void;
  serialsCount: number;
}

export const ProductSerialNumbersMenu: FC<ProductSerialNumbersMenuProps> = ({
  serialsCount,
  anchor,
  close,
  print,
  issueSerialNumbers
}) => {
  const { t } = useTranslation();
  const selectedSerialNumbers = useSelector(getSelectedSerialNumbers);
  const count = useMemo(() => Object.keys(selectedSerialNumbers).length, [selectedSerialNumbers]);

  return (
    <Menu id="serial-numbers-menu" anchorEl={anchor} keepMounted open={Boolean(anchor)} onClose={close}>
      <MenuItem
        onClick={() => {
          close();
          issueSerialNumbers();
        }}
      >
        {t('products.issue serial numbers')}
      </MenuItem>

      {serialsCount > 0 && <Divider />}

      <MenuItem
        disabled={!count}
        onClick={() => {
          close();
          print();
        }}
      >
        {count > 0 && <>{t('print.create labels', { count })}</>}
        {!count && <>{t('print.create labels no selected')}</>}
      </MenuItem>
    </Menu>
  );
};
